import { RouteType } from "./RouteType";
import TransactionsHistory from "../pages/transactions/transactionHistory/TransactionsHistory";
import Distributions from "../pages/transactions/distributions/Distributions";
import CheckRegister from "../pages/transactions/checkRegister/CheckRegister";
import CloseBooks from "../pages/monthEndProcesses/closeBooks/closeBooks";
import ReconcileBankStatement from "../pages/monthEndProcesses/reconcileBankStatement/ReconcileBankStatement";
import LoanStatement from "../pages/reports/loanStatement/LoanStatement";
import InvestmentStatement from "../pages/reports/investmentStatement/InvestmentStatement";
import Summary1099 from "../pages/reports/1099Summary/1099Summary";
import ClientStatements from "../pages/reports/clientStatements/ClientStatements";
import ClientReport from "../pages/reports/clientReport/ClientReport";
import Settings from "../pages/administration/settings/Settings";
import Accounts from "../pages/administration/accounts/Accounts";
import Users from "../pages/administration/users/Users";
import Partnerships from "../pages/administration/partnerships/Partnerships";
import EmailLogs from "../pages/administration/emailLogs/EmailLogs";
import ChangeLog from "../pages/administration/changeLog/ChangeLog";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LoanSummary from "../pages/loanSummary/LoanSummary";
import InvestmentSummary from "../pages/investmentSummary/InvestmentSummary";
import ClientTransactios from "../pages/clientTransactions/ClientTransactios";
import Statements from "../pages/statements/Statements";
import Clients from "../pages/administration/clients/Clients";
import BatchACH from "../pages/transactions/batchACH/BatchACH";
import Form1096 from "../pages/reports/form1096/Form1096";
import OutOfBalance from "../pages/outOfBalance/OutOfBalance";

const appRoutes: RouteType[] = [
  {
    path: "/transactions",
    element: null,
    state: "transactions",
    roles: ["Administrator"],
    sidebarProps: {
      displayText: "Transactions",
      icon: <PaidOutlinedIcon />,
    },
    children: [
      {
        path: "/transactions/transactionHistory",
        element: <TransactionsHistory />,
        roles: ["Administrator"],
        state: "transactions.transactionHistory",
        sidebarProps: {
          displayText: "Transactions History",
        },
      },
      {
        path: "/transactions/distributions",
        element: <Distributions />,
        roles: ["Administrator"],
        state: "transactions.distributions",
        sidebarProps: {
          displayText: "Partnership Distributions",
        },
      },
      {
        path: "/transactions/bulkChecks",
        element: <CheckRegister />,
        roles: ["Administrator"],
        state: "transactions.checkRegister",
        sidebarProps: {
          displayText: "Batch Checks",
        },
      },
      {
        path: "/transactions/batchACH",
        element: <BatchACH />,
        roles: ["Administrator"],
        state: "transactions.batchACH",
        sidebarProps: {
          displayText: "Batch ACH",
        },
      },
    ],
  },
  {
    path: "/monthEndProcesses",
    element: null,
    state: "monthEndProcesses",
    roles: ["Administrator"],
    sidebarProps: {
      displayText: "Month End Processes",
      icon: <EventAvailableOutlinedIcon />,
    },
    children: [
      {
        path: "/monthEndProcesses/closeBooks",
        element: <CloseBooks />,
        roles: ["Administrator"],
        state: "monthEndProcesses.closeBooks",
        sidebarProps: {
          displayText: "Close Books",
        },
      },
      {
        path: "/monthEndProcesses/reconcileBankStatement",
        element: <ReconcileBankStatement />,
        roles: ["Administrator"],
        state: "monthEndProcesses.reconcileBankStatements",
        sidebarProps: {
          displayText: "Reconcile Bank Statement",
        },
      },
    ],
  },
  {
    path: "/reports",
    element: null,
    state: "reports",
    roles: ["Administrator"],
    sidebarProps: {
      displayText: "Reports",
      icon: <ArticleOutlinedIcon />,
    },
    children: [
      {
        path: "/reports/loanStatement",
        element: <LoanStatement />,
        roles: ["Administrator"],
        state: "reports.loanStatement",
        sidebarProps: {
          displayText: "Loan Statement Summary",
        },
      },
      {
        path: "/reports/investmentStatement",
        element: <InvestmentStatement />,
        roles: ["Administrator"],
        state: "reports.investmentStatement",
        sidebarProps: {
          displayText: "Investment Statement Summary",
        },
      },
      {
        path: "/reports/clientStatements",
        element: <ClientStatements />,
        roles: ["Administrator"],
        state: "reports.clientStatements",
        sidebarProps: {
          displayText: "Client Statements",
        },
      },
      {
        path: "/reports/1099Summary",
        element: <Summary1099 />,
        roles: ["Administrator"],
        state: "reports.1099Summary",
        sidebarProps: {
          displayText: "1099 Summary",
        },
      },
      {
        path: "/reports/clientReport",
        element: <ClientReport />,
        roles: ["Administrator"],
        state: "reports.clientReport",
        sidebarProps: {
          displayText: "Client Report",
        },
      },
      {
        path: "/reports/form1096",
        element: <Form1096 />,
        roles: ["Administrator"],
        state: "reports.form1096",
        sidebarProps: {
          displayText: "Form 1096",
        },
      },
    ],
  },
  {
    path: "/administration",
    element: null,
    state: "administration",
    roles: ["Administrator"],
    sidebarProps: {
      displayText: "Administration",
      icon: <SettingsOutlinedIcon />,
    },
    children: [
      {
        path: "/administration/settings",
        element: <Settings />,
        roles: ["Administrator"],
        state: "administration.settings",
        sidebarProps: {
          displayText: "Settings",
        },
      },
      {
        path: "/administration/clients",
        element: <Clients />,
        roles: ["Administrator"],
        state: "administration.clients",
        sidebarProps: {
          displayText: "Clients",
        },
      },
      {
        path: "/administration/accounts",
        element: <Accounts />,
        roles: ["Administrator"],
        state: "administration.accounts",
        sidebarProps: {
          displayText: "Accounts",
        },
      },
      {
        path: "/administration/users",
        element: <Users />,
        roles: ["Administrator"],
        state: "administration.users",
        sidebarProps: {
          displayText: "Users",
        },
      },
      {
        path: "/administration/partnerships",
        element: <Partnerships />,
        roles: ["Administrator"],
        state: "administration.partnerships",
        sidebarProps: {
          displayText: "Partnerships",
        },
      },
      {
        path: "/administration/emailLogs",
        element: <EmailLogs />,
        roles: ["Administrator"],
        state: "administration.emailLogs",
        sidebarProps: {
          displayText: "Email Logs",
        },
      },
      {
        path: "/administration/changeLog",
        element: <ChangeLog />,
        roles: ["Administrator"],
        state: "administration.changeLog",
        sidebarProps: {
          displayText: "Change Log",
        },
      },
    ],
  },
  {
    path: "/clientStatement",
    state: "clientStatement",
    element: <ClientStatements />,
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Client Statement",
      icon: <ReceiptLongIcon />,
    },
  },
  {
    path: "/client1099",
    element: <Summary1099 />,
    state: "client1099",
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Client 1099",
      icon: <DescriptionOutlinedIcon />,
    },
  },
  {
    path: "/loanSummary",
    element: <LoanSummary />,
    state: "loanSummary",
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Loan Summary",
      icon: <ArticleOutlinedIcon />,
    },
  },
  {
    path: "/investmentSummary",
    element: <InvestmentSummary />,
    state: "investmentSummary",
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Investment Summary",
      icon: <TrendingUpOutlinedIcon />,
    },
  },
  {
    path: "/auditorTransactions",
    element: <TransactionsHistory />,
    state: "auditorTransactions",
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Transactions",
      icon: <PaidOutlinedIcon />,
    },
  },
  {
    path: "/reports/form1096",
    element: <Form1096 />,
    roles: ["Auditor"],
    state: "reports.form1096",
    sidebarProps: {
      displayText: "Form 1096",
      icon: <DescriptionOutlinedIcon />,
    },
  },
  {
    path: "/outOfBalance",
    element: <OutOfBalance />,
    state: "outOfBalance",
    roles: ["Auditor"],
    sidebarProps: {
      displayText: "Out of Balance",
      icon: <AccountBalanceIcon />,
    },
  },
  {
    path: "/accounts",
    element: <Accounts />,
    state: "accounts",
    roles: ["Client"],
    sidebarProps: {
      displayText: "Accounts",
      icon: <ReceiptLongIcon />,
    },
  },
  {
    path: "/clientTransactions",
    element: <ClientTransactios />,
    state: "clientTransactions",
    roles: ["Client"],
    sidebarProps: {
      displayText: "Transactions",
      icon: <PaidOutlinedIcon />,
    },
  },
  {
    path: "/statements",
    element: <Statements />,
    state: "statements",
    roles: ["Client"],
    sidebarProps: {
      displayText: "Statements",
      icon: <ArticleOutlinedIcon />,
    },
  },
];

export default appRoutes;
